
<app-loader *ngIf="!isDataReady"></app-loader>
<div class="ui-g" *ngIf="invoiceDetails.length == 0 && isDataReady">
    <span>
        {{ 'no_data_invoice' | translate }}
    </span>
</div>
<div class="ui-g" *ngIf="invoiceDetails.length > 0 && isDataReady">
    <div *ngIf="this._readonly" style="display: block;"> </div>
    <div class="ui-sm-12 ui-md-6 ui-lg-4 ui-xl-4" *ngFor="let detail of invoiceDetails">
        <invoice-details style="cursor: pointer;" (click)="onSelectInvoice(detail)" (editItem)="onEditDetails(detail.id)" (removeItem)="onRemoveItem(detail.id)"
        [selectedInvoiceDetailsId]="(this.selectedInvoice != null) ? this.selectedInvoice.id : ''"
        [readonly]="this._readonly"
        [name] = "detail.name"
        [surname] = "detail.surname"
        [id] =  "detail.id"
        [tax_number] = "detail.tax_number"
        [country] = "detail.country"
        [city] = "detail.city"
        [street] = "detail.street"
        [street_number] = "detail.street_number"
        [apartment_number] = "detail.apartment_number"
        [postal_code] = "detail.postal_code"
        [show_controls] = "1"
        ></invoice-details>
    </div>
</div>

<p-confirmDialog header="{{ 'confirmation' | translate }}" icon="pi pi-exclamation-triangle" acceptLabel="{{ 'yes' | translate }}" rejectLabel="{{ 'no' | translate }}" ></p-confirmDialog>

<p-dialog [header]="((isEditing == true) ? 'edit_invoice_details' : 'add_new_invoice_details') | translate " [(visible)]="display">
    <form [formGroup]="invoiceDetailsForm" (ngSubmit)="onSubmit()">

        <div style="width: 300px;" >
          <div *ngIf="this.invoiceDetailsForm.get('invoice_type').value == 1"><span [innerHTML]="'info_invoice_order_progress' | translate"></span></div>
            <span class="ui-float-label" style="margin-bottom: 20px; margin-top: 10px;">
                <p-selectButton
                  [style]="{'display': 'flex', 'justify-content': 'space-around'}"
                  [options]="typesInvoice"
                  formControlName="invoice_type"
                  (onChange)="onInvoiceTypeChange($event)">
                </p-selectButton>
            </span>

            <span *ngIf="this.invoiceDetailsForm.get('invoice_type').value == 1" class="ui-float-label" style="margin-bottom: 20px; margin-top: 10px;">
              <input id="name-input" formControlName="name" name="name" type="text" pInputText style="width: 100%;">
              <label for="name-input">{{ 'company_name' | translate }}</label>
            </span>

            <span *ngIf="this.invoiceDetailsForm.get('invoice_type').value == 2" class="ui-float-label" style="margin-bottom: 20px; margin-top: 10px;">
              <input id="name-input" formControlName="name" name="name" type="text" pInputText style="width: 100%;">
              <label for="name-input">{{ 'name' | translate }}</label>
            </span>

            <span *ngIf="this.invoiceDetailsForm.get('invoice_type').value == 2" class="ui-float-label" style="margin-bottom: 20px; margin-top: 10px;">
              <input id="surname-input" formControlName="surname" name="surname" type="text" pInputText style="width: 100%;">
              <label for="surname-input">{{ 'surname' | translate }}</label>
            </span>

            <span *ngIf="this.invoiceDetailsForm.get('invoice_type').value == 1" class="ui-float-label">
                <input id="tax_number-input" formControlName="tax_number" name="tax_number" type="text" pInputText style="width: 100%;">
                <label for="tax_number-input">{{ 'tax_number' | translate }}</label>
            </span>

            <div
              *ngIf="this.invoiceDetailsForm.get('invoice_type').value == 1"
              (click)="onLoadGusDataDialog()"
              class="blueColorHover"
              style="font-weight: normal; margin-bottom: 15px;"
            >{{ 'load_gus_data' | translate }}</div>

            <span class="ui-float-label" style="margin-bottom: 20px;">
              <input id="street-input" formControlName="street" name="street" type="text" pInputText style="width: 100%;">
              <label for="street-input">{{ 'street' | translate }}</label>
            </span>

            <span class="ui-float-label" style="margin-bottom: 20px;">
              <input id="street_number-input" formControlName="street_number" name="street_number" type="text" pInputText style="width: 100%;">
              <label for="street_number-input">{{ 'house_no' | translate }}</label>
            </span>

            <span class="ui-float-label" style="margin-bottom: 20px;">
                <input id="apartment_number-input" formControlName="apartment_number" name="apartment_number" type="text" pInputText style="width: 100%;">
                <label for="apartment_number-input">{{ 'apart_no' | translate }}</label>
            </span>

            <span class="ui-float-label" style="margin-bottom: 20px;">
              <input id="postal_code-input" formControlName="postal_code" name="postal_code" type="text" pInputText style="width: 100%;">
              <label for="postal_code-input">{{ 'postal_code' | translate }}</label>
            </span>

            <span class="ui-float-label" style="margin-bottom: 20px;">
              <input id="city-input" formControlName="city" name="city" type="text" pInputText style="width: 100%;">
              <label for="city-input">{{ 'city' | translate }}</label>
            </span>

            <span class="ui-float-label" style="margin-bottom: 10px;">
              
                <!--<input id="country-input" formControlName="country" name="country" type="text" pInputText style="width: 100%;"> -->
                <p-dropdown [style]="{'width': '100%'}"  formControlName="country" [options]="countries"></p-dropdown>

                <label for="country-input">{{ 'country' | translate }}</label>
            </span>

            <p *ngIf="this.invoiceDetailsForm.get('invoice_type').value == 1" style="font-size: 12px;" class="grayColor">{{'recipient_info' | translate}}</p>
            <p *ngIf="this.invoiceDetailsForm.get('invoice_type').value == 1" (click)="showRecipientForm()" style="font-weight: 700; margin-bottom: 10px;" class="blueColorHover">{{'add_recipient_data' | translate}}</p>

        </div>

        <div class="ui-g">
            <div class="ui-g-6">
                <button pButton type="submit" [disabled]="!invoiceDetailsForm.valid" label="{{ 'save' | translate }}" class="ui-button-success" style="width: 100%;"></button>
            </div>
            <div class="ui-g-6">
                <button (click)="cancelForm()" pButton type="button" label="{{ 'cancel' | translate }}" class="ui-button-warning" style="width: 100%;"></button>
            </div>
        </div>
    </form>
</p-dialog>
<p-footer>
    <div style="text-align: right;" *ngIf="!this._readonly">
        <button pButton (click)="addNewDetails()" type="button" icon="pi pi-plus" label="{{ 'add_invoice_details' | translate }}" class="ui-button-info" style="margin-right: .25em;"></button>
    </div>
</p-footer>

<p-dialog header="{{ 'load_gus_data_dialog_header' | translate }}" [(visible)]="gusDialogVisible" [style]="isMobile ? {width: '90vw'} : {width: '50vw'}" [baseZIndex]="10000">
  <div class="ui-g" >
    <div class="ui-sm-12 ui-md-9 ui-md-offset-1 ui-lg-6 ui-lg-offset-3 ui-xl-4 ui-xl-offset-4">
      <span class="ui-float-label">
        <input id="tax-gus-input" [(ngModel)]="gusTaxNumber" type="text" pInputText style="width: 100%;">
        <label for="tax-gus-input">{{ 'tax_number' | translate }}</label>
      </span>
      <span *ngIf="!isNipValid" class="errorMessage">{{ 'enter_valid_tax_number' | translate }}</span>
      <div style="margin-top: 20px;">
        <button pButton type="button" label="{{ 'get_gus_data' | translate }}" (click)="loadGusData()" [disabled]="gusDataLoading || gusTaxNumber.length === 0" class="ui-button-info" style="width:100%"></button>
      </div>
    </div>
  </div>
</p-dialog>

<p-dialog header="{{ 'add_recipient_data' | translate }}" [(visible)]="recipientFormVisible" [style]="{width: '300px'}" [baseZIndex]="10000">
  <form [formGroup]="recipientForm" (ngSubmit)="recipientFormSubmit()">
    <span class="ui-float-label" style="margin-bottom: 20px; margin-top: 10px;">
      <input id="recipient_name-input" formControlName="recipient_name" name="recipient_name" type="text" pInputText style="width: 100%;">
      <label for="recipient_name-input">{{ 'company_name_recipient' | translate }}</label>
    </span>

    <span class="ui-float-label" style="margin-bottom: 20px;">
      <input id="recipient_street-input" formControlName="recipient_street" name="recipient_street" type="text" pInputText style="width: 100%;">
      <label for="recipient_street-input">{{ 'street' | translate }}</label>
    </span>

    <span class="ui-float-label" style="margin-bottom: 20px;">
      <input id="recipient_street_number-input" formControlName="recipient_street_number" name="recipient_street_number" type="text" pInputText style="width: 100%;">
      <label for="recipient_street_number-input">{{ 'house_no' | translate }}</label>
    </span>

    <span class="ui-float-label" style="margin-bottom: 20px;">
      <input id="recipient_postal_code-input" formControlName="recipient_postal_code" name="recipient_postal_code" type="text" pInputText style="width: 100%;">
      <label for="recipient_postal_code-input">{{ 'postal_code' | translate }}</label>
    </span>

    <span class="ui-float-label" style="margin-bottom: 20px;">
      <input id="recipient_city-input" formControlName="recipient_city" name="recipient_city" type="text" pInputText style="width: 100%;">
      <label for="recipient_city-input">{{ 'city' | translate }}</label>
    </span>

    <div class="ui-g">
      <div class="ui-g-6">
        <button pButton type="submit" [disabled]="!recipientForm.valid" label="{{ 'save' | translate }}" class="ui-button-success" style="width: 100%;"></button>
      </div>
      <div class="ui-g-6">
        <button (click)="cancelRecipientForm()" pButton type="button" label="{{ 'cancel' | translate }}" class="ui-button-warning" style="width: 100%;"></button>
      </div>
  </div>
  </form>
</p-dialog>
